// extracted by mini-css-extract-plugin
module.exports = {"masthead":"masthead_masthead__e-wbP","navItem":"masthead_navItem__SNApZ"};